module.exports = __webpack_public_path__ + "static/media/blueChart.277351ba.png";